import http from './api.service';

class PanierService {

    order(panier: any) {
        return http.post('/basket/order', panier,
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    addProduct(panierId, product: any) {
        return http.post('/basket/' + panierId + '/add', product,
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    removeProduct(panierId, productId) {
        return http.delete('/basket/' + panierId + '/product/' + productId,
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    getPanier() {
        return http.get('/getbasket',
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    createPanier() {
        return http.post('/createbasket',
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    postFile(fileId, results, credits, format, segment, type, userId, filters) {
        let basketType = 0;
        switch (type) {
            case "comptage":
                basketType = 1;
                break;
            case "enrichissement":
                basketType = 2;
                break;
            case "qualite":
                basketType = 3;
                break;
            default:
                basketType = 0;
        }

        const params = {
            userId: userId.toString(),
            segment: segment,
            result: results,
            credit: credits,
            format: format,
            fileId: fileId,
            basketType: basketType,
            filters: filters,
        };
        return http.post('/basket', params,
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    putBasket(basketId, fileId, results, credits, format, segment, type, userId, basketStatus, email, filters) {
        let basketType = 0;
        let moduleId = 0;
        switch (type) {
            case "comptage":
                basketType = 1;
                moduleId = 34;
                break;
            case "enrichissement":
                basketType = 2;
                moduleId = 35;
                break;
            case "qualite":
                basketType = 3;
                moduleId = 36;
                break;
            default:
                basketType = 0;
        }
        const params = {
            basketId: basketId,
            userId: userId.toString(),
            segment: segment,
            result: results,
            credit: credits,
            format: format,
            basketType: basketType,
            status: basketStatus,
            email: email,
            filters: filters,
            fileId: fileId
        };

        return http.put('/basket', params,
            {
                headers: {'Content-Type': 'application/json'}
            });
    }

    getBasketsFromUser(userId, status) {
        return http.get('/basket/all/' + userId, {
            params: {'basketStatus': status},
            headers: {'Content-Type': 'application/json'}
        })
    }

    getCurrentBasketFromUser(userId) {
        return http.get('/basket/all/' + userId, {
            params: {'basketStatus': 'current'},
            headers: {'Content-Type': 'application/json'}
        });
    }

    getFileFromId(basketId) {
        return http.get('/basket/' + basketId, {headers: {'Content-Type': 'application/json'}})
    }

    deleteBasket(basketId) {
        return http.delete('/basket/remove/' + basketId)
    }

    getFile(basketId) {
        const params = new URLSearchParams();
        params.append('basketId', basketId);
        return http.get('/order', {params: params})
    }

    dealWithMultipleBasket(baskets, user) {
        const body = {
            "baskets": baskets,
            "email": user.email
        };
        return http.post('/baskets', body, {headers: {'Content-Type': 'application/json'}})
    }


}

export default new PanierService();
